// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3yhNP","unreadBadge":"styles_unreadBadge__gBcn_","modalContent":"styles_modalContent__UYM00","modal":"styles_modal__381d8"};